<template>
    <div id="tw-privacy-policy" class="content">
      <LoginLogo />

      <v-container>
        <v-row>
          <v-col>
            <h1>TubeWay - Privacy Policy</h1>

            <p>
              Last Updated: March 1, 2022
            </p>

            <p>
This privacy policy (“Privacy Policy“) describes how Video Bee BV, operator of the TubeWay platform,
and its related companies (“Tubeway“, “ Company“, “ we“, “ us“, “ our“) collect, use and share personal
information of consumer users of this website, https://www.tubeway.io (the “Site“), the Tubeway
web/mobile apps, Final Cut Pro and Adobe premiere extensions and email add-ins.
            </p>

            <h3><b>What We Collect</b></h3>

            <p>
We may collect information that identifies you (“Personal Data”) when you use the Site which
includes:
</p>

<p>
<b>Identity Data</b> includes first name, last name, username or similar identifier.<br/>
<b>Contact Data</b> includes billing address, email address and telephone numbers.<br/>
<b>Financial Data</b> includes payment card details.<br/>
<b>Transaction Data</b> includes details about payments to and from you and other details of products and
services you have purchased from us.<br/>
<b>Technical Data</b> includes internet protocol (IP) address, your login data, browser type and version,
time zone setting and location, browser plug-in types and versions, operating system and platform
and other technology on the devices you use to access this Site.<br/>
<b>Profile Data</b> includes your email and password, purchases or orders made by you, your preferences,
feedback and survey responses.<br/>
<b>Usage Data</b> includes information about how you use our Site, products and services.
<b>Marketing and Communications Data</b> includes your preferences in receiving marketing from us and
our third parties and your communication preferences.<br/>
We get Personal Data about you in a range of ways.<br/>
<b>Information You Give Us.</b> We collect information you directly give us on our Site.
<b>Information We Get From Others.</b> We may get information about you from other sources. We may
add this to information we get from this Site.<br/>
<b>Information Automatically Collected.</b> We automatically log information about you and your
computer. For example, when visiting our Site, we log your computer operating system type, browser
type, browser language, the website you visited before browsing to our Site, pages you viewed, how
long you spent on a page, access times and information about your use of and actions on our Site.<br/>
<b>Cookies.</b> We may log information using “cookies.” Cookies are small data files stored on your hard
drive by a website. We may use both session Cookies (which expire once you close your web
browser) and persistent Cookies (which stay on your computer until you delete them) to provide you
with a more personal and interactive experience on our Site. This type of information is collected to
make the Site more useful to you and to tailor the experience with us to meet your special interests
and needs.
</p>

<p>
The Site is not intended for children and we do not knowingly collect data relating to children.
</p>

<h3>Use of Personal Data</h3>
<p>We use your Personal Data as follows:</p>
<ul>
    <li>To operate, maintain, and improve our sites, products, and services.</li>
    <li>To respond to comments and questions and provide customer service.</li>
    <li>To send information including confirmations, invoices, technical notices, updates, security alerts, and support and administrative messages.</li>
    <li>To communicate about promotions, upcoming events, and other news about products and services offered by us and our selected partners.</li>
    <li>To link or combine user information with other Personal Data.</li>
    <li>To protect, investigate, and deter against fraudulent, unauthorized, or illegal activity.</li>
    <li>To provide and deliver products and services customers request.</li>
</ul>
<br/>
<h3>Sharing of Personal Data</h3>
<p>We may share Personal Data as follows:</p>
<ul>
    <li>We may share Personal Data with your consent. For example, you may let us share Personal Data with others for their own marketing uses. Those uses will be subject to their privacy policies.</li>
    <li>We may share Personal Data when we do a business deal, or negotiate a business deal, involving the sale or transfer of all or a part of our business or assets. These deals can include any merger, financing, acquisition, or bankruptcy transaction or proceeding.</li>
    <li>We may share Personal Data for legal, protection, and safety purposes.
        <ul>
            <li>We may share information to comply with laws.</li>
            <li>We may share information to respond to lawful requests and legal processes.</li>
            <li>We may share information to protect the rights and property of Tubeway, our agents, customers, and others. This includes enforcing our agreements, policies, and terms of use.</li>
            <li>We may share information in an emergency. This includes protecting the safety of our employees and agents, our customers, or any person.</li>
        </ul>
    </li>
    <li>We may share information with those who need it to do work for us.</li>
</ul>
<p>We may also share aggregated and/or anonymized data with others for their own uses.</p>

<br/>
<h3>Information Choices and Changes</h3>
<p>
Our marketing emails tell you how to “opt-out.” If you opt out, we may still send you non- marketing
emails. Non-marketing emails include emails about your accounts and our business dealings with
you.
</p>
<p>
You may send requests about Personal Data to our Contact Information below. You can request to
change contact choices, opt-out of our sharing with others, and update your Personal Data.
</p>
<p>
You can typically remove and reject cookies from our Site with your browser settings. Many browsers
are set to accept cookies until you change your settings. If you remove or reject our cookies, it could
affect how our Site works for you.
</p>

<h3>Your California Privacy Rights</h3>
<p>
California Civil Code Section § 1798.83 permits users of our Website that are California residents to
request certain information regarding our disclosure of personal information to third parties for their
direct marketing purposes. To make such a request, please contact us at the Contact Information
below.
</p>
<h3>For Residents of the European Union (“EU”) - General Data Protection Regulation (“GDPR”)</h3>
<p>
This Privacy Policy describes how the Company collects, uses and shares your personal information. If
you are a resident of the EU, you are subject to the GDPR, which becomes effective on May 25, 2018,
and the following terms also apply to you. The Company is the Controller and responsible for your
Personal Data.
</p>
<p>
We have appointed a data protection officer (DPO) who is responsible for overseeing questions in
relation to this Privacy Policy. If you have any questions about this Privacy Policy, including any
requests to exercise your legal rights, please contact the DPO using the details set out below.
</p>
<p>
Email: support@tubeway.io<br/>
Attention: Privacy
</p>

<h3>Purposes and Lawful Bases to Process Your Personal Data</h3>
<p>This Privacy Policy describes the Personal Data we collect from you and how we use it. We will only use your Personal Data when the law allows us to. Most commonly, we will use your Personal Data in the following circumstances:</p>
<ul>
    <li>Where we need to perform the contract we are about to enter into or have entered into with you.</li>
    <li>Where it is necessary for our legitimate interests (or those of a third party) and your interests and fundamental rights do not override those interests.</li>
    <li>Where we need to comply with a legal or regulatory obligation.</li>
</ul>
<p>You have the right to withdraw consent to marketing at any time by contacting us.</p>
<p>We have a purpose and lawful basis for processing each type of Personal Data described in this Privacy Policy, which are as follows:</p>
<ol>
  <li>The purpose for collecting your Identity and Contact Data is to register you as a new
    customer, and the lawful basis is the performance of a contract with you. </li>
  <li>The purpose for collecting your Identity, Contact, Financial, Transaction and Marketing and
Communications Data is to process and deliver your purchases, and the lawful bases are (a)
the performance of a contract with you and (b) it is necessary for our legitimate interests.</li>
  <li>The purpose for collecting your Identity, Contact, Profile, and Marketing and
Communications Data is to manage a relationship with you, and the lawful bases are (a) the
performance of a contract with you and (b) it is necessary for our legitimate interests (to
keep our records updated and to study how customers use our products/services). </li>
  <li>The purpose for collecting your Identity, Contact, Profile, Usage, and Marketing and
Communications Data is to enable you complete a survey. The lawful bases are (a) the
performance of a contract with you and (b) it is necessary for our legitimate interests (to
study how customers use our products and services, to develop them and grow our
business).</li>
  <li>The purpose for collecting your Identity, Contact, and Technical Data is to administer and
protect our business and the Site, and the lawful basis is that it is necessary for our
legitimate interests (for running our business, provision of administration and IT services,
network security, to prevent fraud and in the context of a business reorganization or group
restructuring exercise).</li>
  <li>The purpose for collecting your Identity, Contact, Profile, Usage, Marketing and
Communications, and Technical Data is to deliver relevant Site content to you and measure
or understand the effectiveness of the advertising we serve to you, and the lawful basis is
that it is necessary for our legitimate interests (to study how customers use our
products/services, to develop them, to grow our business and to inform our marketing
strategy). </li>
  <li>The purpose for collecting Technical and Usage Data is to use data analytics to improve our
Site, marketing, customer relationships and experiences, and the lawful basis is that it is
necessary for our legitimate interests (to define types of customers for our products and
services, to keep our Site updated and relevant, to develop our business and to inform our
marketing strategy).</li>
  <li>The purpose for collecting Identity, Contact, Profile, Usage, and Technical Data is to make
suggestions and recommendations to you about goods or services that may be of interest to
you, and the lawful basis is that it is necessary for legitimate interests (to develop our
products/services and grow our business).</li>
</ol>

<p>
We do not collect any Special Categories of Personal Data about you (this includes details about your
race or ethnicity, religious or philosophical beliefs, sex life, sexual orientation, political opinions, trade
union membership, information about your health and genetic and biometric data). Nor do we
collect any information about criminal convictions and offences.
</p>
<p>
Note that we may process your Personal Data for more than one lawful ground depending on the
specific purpose for which we are using your data. Please contact us if you need details about the
specific legal ground we are relying on to process your Personal Data where more than one ground
has been set out forth in this Privacy Policy.
</p>
<p>
We may have to share your Personal Data with the parties set out below for the purposes described
in this Privacy Policy.
</p>

<p><b>Internal Third Parties</b></p>
<p>
Other companies affiliated with the Company acting as joint controllers or processors and who are
based in the Netherlands and Bulgaria.</p>
<p><b>External Third Parties</b></p>
<ul>
  <li>Service providers acting as processors based in the EU who provide infrastructure services
(Amazon Web Services), advertising services (Facebook, Google, Microsoft Bing, LinkedIn),
Billing Services (Stripe), Customer Service (Intercom, Pipedrive, Wootric), Email Service
(Mailchimp/Mandrill).</li>
<li>Professional advisers acting as processors or joint controllers including lawyers, bankers,
auditors and insurers based in the Netherlands who provide consultancy, banking, legal,
insurance and accounting services.</li>
<li>Third parties to whom we may choose to sell, transfer, or merge parts of our business or our
assets. Alternatively, we may seek to acquire other businesses or merge with them. If a
change happens to our business, then the new owners may use your Personal Data in the
same way as set out in this Privacy Policy.</li>
</ul>

<p>We require all third parties to respect the security of your Personal Data and to treat it in accordance
with the law. We do not allow our third-party service providers to use your Personal Data for their
own purposes and only permit them to process your Personal Data for specified purposes and in
accordance with our instructions. </p>
<p><b>International Processing</b></p>
<p>We are based in the Netherlands and Bulgaria with servers running in Ireland, which is where all of
your data will be processed. </p>
<p><b>Data Security</b></p>
<p>We have put in place appropriate security measures to prevent your Personal Data from being
accidentally lost, used or accessed in an unauthorized way, altered or disclosed. In addition, we limit
access to your Personal Data to those employees, agents, contractors and other third parties who
have a business need to know. They will only process your Personal Data on our instructions and they
are subject to a duty of confidentiality. We have put in place procedures to deal with any suspected
Personal Data breach and will notify you and any applicable regulator of a breach where we are
legally required to do so.</p>
<p><b>Data Retention</b></p>
<p>We will only retain your Personal Data for as long as necessary to fulfil the purposes we collected it
for, including for the purposes of satisfying any legal, accounting, or reporting requirements. To
determine the appropriate retention period for Personal Data, we consider the amount, nature, and
sensitivity of the Personal Data, the potential risk of harm from unauthorized use or disclosure of
your Personal Data, the purposes for which we process your Personal Data and whether we can
achieve those purposes through other means, and the applicable legal requirements. In some
circumstances you can ask us to delete your data. In some circumstances we may anonymize your
Personal Data (so that it can no longer be associated with you) for research or statistical purposes in
which case we may use this information indefinitely without further notice to you. </p>

<h3>YOUR LEGAL RIGHTS UNDER THE GDPR</h3>
<p>Under certain circumstances, EU residents have rights under data protection laws in relation to their Personal Data. If you are an EU resident, you have the right to:</p>
<ul>
    <li><strong>Request access to your Personal Data:</strong> This enables you to receive a copy of the Personal Data we hold about you and to check that we are lawfully processing it.</li>
    <li><strong>Request correction of the Personal Data</strong> that we hold about you. This enables you to have any incomplete or inaccurate data we hold about you corrected, though we may need to verify the accuracy of the new data you provide to us.</li>
    <li><strong>Request erasure of your Personal Data.</strong> This enables you to ask us to delete or remove Personal Data where there is no good reason for us continuing to process it. You also have the right to ask us to delete or remove your Personal Data where you have successfully exercised your right to object to processing (see below), where we may have processed your information unlawfully, or where we are required to erase your Personal Data to comply with local law. Note, however, that we may not always be able to comply with your request of erasure for specific legal reasons, which will be notified to you, if applicable, at the time of your request.</li>
    <li><strong>Object to processing of your Personal Data</strong> where we are relying on a legitimate interest (or those of a third party) and there is something about your particular situation which makes you want to object to processing on this ground, as you feel it impacts on your fundamental rights and freedoms. You also have the right to object where we are processing your Personal Data for direct marketing purposes. In some cases, we may demonstrate that we have compelling legitimate grounds to process your information which override your rights and freedoms.</li>
    <li><strong>Request restriction of processing of your Personal Data.</strong> This enables you to ask us to suspend the processing of your Personal Data in the following scenarios:
        <ul>
            <li>(a) if you want us to establish the data’s accuracy;</li>
            <li>(b) where our use of the data is unlawful but you do not want us to erase it;</li>
            <li>(c) where you need us to hold the data even if we no longer require it as you need it to establish, exercise or defend legal claims; or</li>
            <li>(d) you have objected to our use of your data but we need to verify whether we have overriding legitimate grounds to use it.</li>
        </ul>
    </li>
    <li><strong>Request the transfer of your Personal Data</strong> to you or to a third party. We will provide to you, or a third party you have chosen, your Personal Data in a structured, commonly used, machine-readable format. Note that this right only applies to automated information which you initially provided consent for us to use or where we used the information to perform a contract with you.</li>
    <li><strong>Withdraw consent at any time</strong> where we are relying on consent to process your Personal Data. However, this will not affect the lawfulness of any processing carried out before you withdraw your consent. If you withdraw your consent, we may not be able to provide certain products or services to you. We will advise you if this is the case at the time you withdraw your consent.</li>
</ul>

<p>
  If you wish to exercise any of the rights set out above, please contact us. You will not have to pay a
fee to access your Personal Data (or to exercise any of the other rights). However, we may charge a
reasonable fee if your request is clearly unfounded, repetitive or excessive.
</p>

<p>
  Alternatively, we may refuse to comply with your request in these circumstances. We may need to
request specific information from you to help us confirm your identity and ensure your right to
access your Personal Data (or to exercise any of your other rights). This is a security measure to
ensure that Personal Data is not disclosed to any person who has no right to receive it. We may also
contact you to ask you for further information in relation to your request to speed up our response.
We try to respond to all legitimate requests within one month. Occasionally it may take us longer
than a month if your request is particularly complex or you have made a number of requests. In this
case, we will notify you and keep you updated.
</p>

<p><b>Contact Information</b></p>
<p>
We welcome your comments or questions about this Privacy Policy. You may email us at
support@Tubeway.io.
</p>
          </v-col>
        </v-row>
      </v-container>
    </div>
</template>

<script>
import LoginLogo from './components/LoginLogo.vue'

export default {
  name: "PrivacyPolicy",
  components: {
    LoginLogo,
  }
}
</script>

<style scoped>
#tw-privacy-policy {
  p {
    margin-bottom: 16px;
  }

  ul, ol {
      padding-left: 24px;
  }
}
</style>
